import { Jogador } from "./Jogador";

export default Jogador;